import { memo, useState } from "react";
import { Box, Typography } from "@mui/material";
import AddCircle from "../assets/icons/add-circle.svg";
import CloseCircle from "../assets/icons/close-circle.svg";
import T01_59s from "../assets/templates/T01_59s.png";
import T01_merge30sPlus30s from "../assets/templates/T01_merge30sPlus30s.png";
import T02_mergeMusic30sPlus30s from "../assets/templates/T02_mergeMusic30sPlus30s.png";
import T02_music59s from "../assets/templates/T02_music59s.png";
import T33_59s from "../assets/templates/T33_59s.png";
import T33_merge30sPlus30s from "../assets/templates/T33_merge30sPlus30s.png";

const Templates = ({ templates, currentTemplate, setCurrentTemplate }) => {
  const [isOpenTemplate, setIsOpenTemplate] = useState(true);

  const handleTemplateChange = (templateName) => {
    const template = templates.find(
      (template) => template.name === templateName
    );

    if (template) {
      setCurrentTemplate(template);
    } else {
      setCurrentTemplate(null);
    }
  };

  const getTemplateImage = (val) =>
    ({
      T01_59s: T01_59s,
      T01_merge30sPlus30s: T01_merge30sPlus30s,
      T02_mergeMusic30sPlus30s: T02_mergeMusic30sPlus30s,
      T02_music59s: T02_music59s,
      T33_59s: T33_59s,
      T33_merge30sPlus30s: T33_merge30sPlus30s,
    }[val]);

  if (!templates?.length) return null;

  return (
    <Box
      sx={{
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#000000",
        paddingX: "16px",
        paddingY: "14px",
        backgroundColor: "#ffffff",
        width: "100%",
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => setIsOpenTemplate((prev) => !prev)}
      >
        <Typography
          sx={{
            color: "rgba(110,90,180, 1)",
            fontWeight: "500",
            fontSize: "36px",
            marginRight: "12px",
          }}
        >
          TEMPLATE
        </Typography>
        {isOpenTemplate ? (
          <img
            src={CloseCircle}
            alt="close-circle"
            style={{ width: "35px", height: "35px" }}
          />
        ) : (
          <img
            src={AddCircle}
            alt="add-circle"
            style={{ width: "35px", height: "35px" }}
          />
        )}
      </Box>
      <Box
        sx={{
          overflowX: "scroll",
          overflowY: "hidden",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "10px",
          marginBottom: isOpenTemplate ? "10px" : "0px",
          marginTop: isOpenTemplate ? "10px" : "0px",
          transition: "all 0.5s ease",
          height: isOpenTemplate ? "567px" : "0px",
        }}
      >
        {templates.map((template) => {
          return (
            <Box
              key={template.name}
              sx={{ position: "relative", cursor: "pointer" }}
              onClick={() => handleTemplateChange(template.name)}
            >
              <Box
                style={{
                  transition: "all 0.3s ease",
                  opacity: template.name !== currentTemplate?.name ? 1 : 0,
                  position: "absolute",
                  top: 7,
                  left: 7,
                  bottom: 10,
                  right: 7,
                  backgroundColor: "rgba(0,0,0,0.75)",
                }}
              />
              <img
                src={getTemplateImage(template.name)}
                alt="template"
                style={{ width: "284px", heigth: "564px" }}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default memo(Templates);
